import { useState, useMemo } from "react";
import {
  Star, Tag, Search, Gift, Heart, Award, Trophy, Crown, Sparkles, Zap,
  Coffee, Pizza, Utensils, ShoppingBag, ShoppingCart, CreditCard, Wallet, Percent, BadgePercent, Ticket,
  Smartphone, Wrench, Hammer, Battery, Wifi, Headphones, Camera, Monitor, Laptop, Tv,
  Calendar, Clock, MapPin, Home, Building, Store, Car, Plane, Train, Bike,
  Users, User, UserPlus, MessageCircle, Mail, Phone, Bell, Shield, Lock, Key,
  Music, Film, Gamepad2, Book, BookOpen, GraduationCap, Briefcase, Lightbulb, Leaf, Flower,
  Dumbbell, Activity, Pill, Stethoscope, Baby, Dog, ChefHat, Wine, Beer, IceCream,
  Cake, Apple, Truck, Package, Box, Image as ImageIcon, Palette, Brush, Scissors, Shirt,
} from "lucide-react";

const ICONS: Record<string, any> = {
  star: Star, tag: Tag, search: Search, gift: Gift, heart: Heart, award: Award, trophy: Trophy, crown: Crown, sparkles: Sparkles, zap: Zap,
  coffee: Coffee, pizza: Pizza, utensils: Utensils, "shopping-bag": ShoppingBag, "shopping-cart": ShoppingCart, "credit-card": CreditCard, wallet: Wallet, percent: Percent, "badge-percent": BadgePercent, ticket: Ticket,
  smartphone: Smartphone, wrench: Wrench, hammer: Hammer, battery: Battery, wifi: Wifi, headphones: Headphones, camera: Camera, monitor: Monitor, laptop: Laptop, tv: Tv,
  calendar: Calendar, clock: Clock, "map-pin": MapPin, home: Home, building: Building, store: Store, car: Car, plane: Plane, train: Train, bike: Bike,
  users: Users, user: User, "user-plus": UserPlus, "message-circle": MessageCircle, mail: Mail, phone: Phone, bell: Bell, shield: Shield, lock: Lock, key: Key,
  music: Music, film: Film, gamepad: Gamepad2, book: Book, "book-open": BookOpen, "graduation-cap": GraduationCap, briefcase: Briefcase, lightbulb: Lightbulb, leaf: Leaf, flower: Flower,
  dumbbell: Dumbbell, activity: Activity, pill: Pill, stethoscope: Stethoscope, baby: Baby, dog: Dog, "chef-hat": ChefHat, wine: Wine, beer: Beer, "ice-cream": IceCream,
  cake: Cake, apple: Apple, truck: Truck, package: Package, box: Box, image: ImageIcon, palette: Palette, brush: Brush, scissors: Scissors, shirt: Shirt,
};

export function getIcon(name?: string | null) {
  if (!name) return Star;
  return ICONS[name.toLowerCase()] ?? Star;
}

export function IconPicker({ value, onChange }: { value?: string | null; onChange: (v: string) => void }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const Current = getIcon(value);
  const filtered = useMemo(() => {
    const t = q.trim().toLowerCase();
    return Object.entries(ICONS).filter(([k]) => !t || k.includes(t));
  }, [q]);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="input-mini flex items-center gap-2 w-full text-left"
      >
        <Current size={16} />
        <span className="flex-1 text-sm">{value || "Välj ikon"}</span>
      </button>
      {open && (
        <div className="absolute z-30 mt-1 w-72 rounded-xl border border-border bg-white shadow-lg p-2">
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Sök ikon…"
            className="input-mini mb-2 w-full"
          />
          <div className="grid grid-cols-6 gap-1 max-h-60 overflow-y-auto">
            {filtered.map(([name, Ico]) => (
              <button
                type="button"
                key={name}
                onClick={() => { onChange(name); setOpen(false); }}
                title={name}
                className={`aspect-square flex items-center justify-center rounded-lg border hover:bg-muted ${value === name ? "border-[var(--color-primary)] bg-muted" : "border-transparent"}`}
              >
                <Ico size={16} />
              </button>
            ))}
            {!filtered.length && <p className="col-span-6 text-xs text-muted-foreground text-center py-4">Ingen ikon matchade.</p>}
          </div>
        </div>
      )}
    </div>
  );
}
